"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCaddiePolicy = void 0;
const getCaddiePolicy = (rate) => {
    if (!rate?.caddie_policy)
        return null;
    return rate.caddie_policy;
};
exports.getCaddiePolicy = getCaddiePolicy;
